module.exports = __webpack_public_path__ + "static/media/Videos@2x.13918c78.webp";